import Reader from './component';
import { getDefaultSession, getFirstUnitOfSession } from 'data/SessionPlans/accessors';

export default ({ getState }) => ({
  path: 'reading',
  component: Reader,
  actionButtons: {
    default: {
      'View Content': {
        route: ({ params }) => {
          const { groupId } = params;
          const sessionId = getDefaultSession(getState(), groupId).id;
          const unitId = getFirstUnitOfSession(getState(), sessionId);
          return `/group/${groupId}/assign-homework/session/${sessionId}/unit/${unitId}`;
        },
      },
    },
  },
});



// WEBPACK FOOTER //
// ./containers/Group/Homework/Reader/routes.js